export enum ModelType {
    KERAS_MODEL = 'keras-model',
    MLLIB_MODEL = 'mllib-model',
    MLLIB_TRANSFORMER = 'mllib-transformer',
    MLLIB_PIPELINE = 'mllib-pipeline',
    SKLEARN_MODEL = 'sklearn-model',
    SKLEARN_TRANSFORMER = 'sklearn-transformer',
    SKLEARN_PIPELINE = 'sklearn-pipeline',
}
